import { cleanAlternativesPaginatedS, startLoadingAlternativesByTextAlternativePaginated } from "../actions/alternativeActions";
import { cleanAssistancesPaginatedS, startLoadingAssistancesByTextAssistancePaginated } from "../actions/assistanceActions";
import { cleanExperiencesPaginatedS, startLoadingExperiencesByTextExperiencePaginated } from "../actions/experienceActions";
import { cleanFinancialsPaginatedS, startLoadingFinancialsByTextFinancialPaginated } from "../actions/financialActions";
import { cleanInnovationsPaginatedS, startLoadingInnovationsByTextInnovationPaginated } from "../actions/innovationActions";
import { cleanRegulationsPaginatedS, startLoadingRegulationsByTextRegulationPaginated } from "../actions/regulationActions";
import { cleanTechnologiesPaginatedS, startLoadingTechnologiesByTextTechnologyPaginated } from "../actions/technologyActions";
import { cleanVisionsPaginatedS, startLoadingVisionsByTextVisionPaginated, startLoadingVisionsByTextVisionPaginatedNoCiiu } from "../actions/visionActions";

export const MODULE_SEARCH_CONFIG_GENERIC = {
    technology: {
        isEnabled: (env) => env.searchModuleTechnologyEnabled === "true",
        action: (p) => startLoadingTechnologiesByTextTechnologyPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanTechnologiesPaginatedS
    },
    alternative: {
        isEnabled: (env) => env.searchModuleAlternativeEnabled === "true",
        action: (p) => startLoadingAlternativesByTextAlternativePaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanAlternativesPaginatedS
    },
    experience: {
        isEnabled: (env) => env.searchModuleExperienceEnabled === "true",
        action: (p) => startLoadingExperiencesByTextExperiencePaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanExperiencesPaginatedS
    },
    innovation: {
        isEnabled: (env) => env.searchModuleInnovationEnabled === "true",
        action: (p) => startLoadingInnovationsByTextInnovationPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanInnovationsPaginatedS
    },
    assistance: {
        isEnabled: (env) => env.searchModuleAssistanceEnabled === "true",
        action: (p) => startLoadingAssistancesByTextAssistancePaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanAssistancesPaginatedS
    },
    financial: {
        isEnabled: (env) => env.searchModuleFinancialEnabled === "true",
        action: (p) => startLoadingFinancialsByTextFinancialPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanFinancialsPaginatedS
    },
    regulation: {
        isEnabled: (env) => env.searchModuleRegulationEnabled === "true",
        action: (p) => startLoadingRegulationsByTextRegulationPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        cleanAction: cleanRegulationsPaginatedS
    },
    vision: {
        isEnabled: (env) => env.searchModuleVisionEnabled === "true",
        //action: (p) => startLoadingVisionsByTextVisionPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1),
        action: (p) => startLoadingVisionsByTextVisionPaginatedNoCiiu(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter),
        cleanAction: cleanVisionsPaginatedS
    }
};

export const MODULE_SEARCH_CONFIG_GENERIC_BK = {
    technology: {
        isEnabled: (env) => env.searchModuleTechnologyEnabled === "true",
        action: (p) => startLoadingTechnologiesByTextTechnologyPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    alternative: {
        isEnabled: (env) => env.searchModuleAlternativeEnabled === "true",
        action: (p) => startLoadingAlternativesByTextAlternativePaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    experience: {
        isEnabled: (env) => env.searchModuleExperienceEnabled === "true",
        action: (p) => startLoadingExperiencesByTextExperiencePaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    innovation: {
        isEnabled: (env) => env.searchModuleInnovationEnabled === "true",
        action: (p) => startLoadingInnovationsByTextInnovationPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    assistance: {
        isEnabled: (env) => env.searchModuleAssistanceEnabled === "true",
        action: (p) => startLoadingAssistancesByTextAssistancePaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    financial: {
        isEnabled: (env) => env.searchModuleFinancialEnabled === "true",
        action: (p) => startLoadingFinancialsByTextFinancialPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    regulation: {
        isEnabled: (env) => env.searchModuleRegulationEnabled === "true",
        action: (p) => startLoadingRegulationsByTextRegulationPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    },
    vision: {
        isEnabled: (env) => env.searchModuleVisionEnabled === "true",
        action: (p) => startLoadingVisionsByTextVisionPaginated(p.text, p.page, p.size, p.catalogToFilter, p.indicatorToFilter, p.codeCiiuLevel1)
    }
};

//Indicator[], page 0, se podria hacer un generico o a su ves hacer uno por tipo hacer primero uno por tipo
export const MODULE_SEARCH_CONFIG = {
    technology: {
        isEnabled: (env) => env.searchModuleTechnologyEnabled === "true",
        action: (p) => startLoadingTechnologiesByTextTechnologyPaginated(p.text, 0, p.size, p.catalog, [], p.code)
    },
    alternative: {
        isEnabled: (env) => env.searchModuleAlternativeEnabled === "true",
        action: (p) => startLoadingAlternativesByTextAlternativePaginated(p.text, 0, p.size, p.catalog, [])
    },
    experience: {
        isEnabled: (env) => env.searchModuleExperienceEnabled === "true",
        action: (p) => startLoadingExperiencesByTextExperiencePaginated(p.text, 0, p.size, p.catalog, [])
    },
    innovation: {
        isEnabled: (env) => env.searchModuleInnovationEnabled === "true",
        action: (p) => startLoadingInnovationsByTextInnovationPaginated(p.text, 0, p.size, p.catalog, [])
    },
    assistance: {
        isEnabled: (env) => env.searchModuleAssistanceEnabled === "true",
        action: (p) => startLoadingAssistancesByTextAssistancePaginated(p.text, 0, p.size, p.catalog, [])
    },
    financial: {
        isEnabled: (env) => env.searchModuleFinancialEnabled === "true",
        action: (p) => startLoadingFinancialsByTextFinancialPaginated(p.text, 0, p.size, p.catalog, [])
    },
    regulation: {
        isEnabled: (env) => env.searchModuleRegulationEnabled === "true",
        action: (p) => startLoadingRegulationsByTextRegulationPaginated(p.text, 0, p.size, p.catalog, [])
    },
    vision: {
        isEnabled: (env) => env.searchModuleVisionEnabled === "true",
        action: (p) => startLoadingVisionsByTextVisionPaginated(p.text, 0, p.size, p.catalog, [])
    }
};
